import { logout } from "../features/auth/AuthSlice";

function forbiddenHandler(args: any, api: any) {
  const isAuthenticated: any = localStorage.getItem("isAuthenticated");
  const token: string | any = localStorage.getItem("token");
  const loginUrl = args.url === "https://reqres.in/api/login";

  if ((!isAuthenticated || !token) && !loginUrl) {
    api.dispatch(logout());
  }
}

export default forbiddenHandler;
